import { configureStore } from "@reduxjs/toolkit";
import ohlcReducer from "./slices/ohlcSlice";
import analysisReducer from "./slices/analysisSlice";
import uiReducer from "./slices/uiSlice";
import fibLevelsReducer from "./slices/fibLevelsSlice";
import drawingSetsReducer from "./slices/drawingSetsSlice";
import tabsReducer from "./slices/tabsSlice";
import workspacesReducer from "./slices/workspacesSlice";
import meReducer from "./slices/meSlice";
import tourReducer from "./slices/tourSlice";
import tradingReducer from "./slices/tradingSlice";
import signalReducer from "./slices/signalSlice";
import strategiesReducer from "./slices/strategiesSlice";
import journalReducer from "./slices/journalSlice";
import userPrefsReducer from "./slices/userPrefsSlice";
import sessionBoundariesReducer from "./slices/sessionBoundariesSlice";
import notesReducer from "./slices/notesSlice";
import newsReducer from "./slices/newsSlice";
import replayReducer from "./slices/replaySlice";
import notificationsReducer from "./slices/notificationsSlice";
import chatReducer from "./slices/chatSlice";
import appearanceReducer, {
  appearanceListener,
} from "./slices/appearanceSlice";
import { analyticsMiddleware } from "@/analytics/middleware";

export const store = configureStore({
  reducer: {
    tabs: tabsReducer,
    ohlc: ohlcReducer,
    replay: replayReducer,
    analysis: analysisReducer,
    ui: uiReducer,
    fibLevels: fibLevelsReducer,
    drawingSets: drawingSetsReducer,
    workspaces: workspacesReducer,
    me: meReducer,
    trading: tradingReducer,
    signal: signalReducer,
    strategies: strategiesReducer,
    journal: journalReducer,
    userPrefs: userPrefsReducer,
    sessionBoundaries: sessionBoundariesReducer,
    notes: notesReducer,
    news: newsReducer,
    notifications: notificationsReducer,
    chat: chatReducer,
    appearance: appearanceReducer,
    tour: tourReducer,
  },
  // Persists the light/dark pick on setTheme/toggleTheme only — see the
  // listener in appearanceSlice for why it must not write on mount.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .prepend(appearanceListener.middleware)
      .concat(analyticsMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
